/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_ActiveInputs */



/**
* | output |
* | --- |
* | "Active" |
*
* @param {Subscription_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_active = /** @type {((inputs?: Subscription_ActiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_ActiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actif")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktiv")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("积极的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रिय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativo")
	return /** @type {LocalizedString} */ ("Active")
});